export const LOCAL_STORAGE_KEY = 'first-point';
export const SESSION_STORAGE_KEY = 'session-point';

export const email = 'a.fedosov@andersenlab.com';

export const meetupDate = '2025-06-05';
export const meetupTime = '10 AM CDT | 4 PM BST | 5 PM CEST | 7 PM GST';
